
import Divisor from './Divisor';
import TituloNegrito from './TituloNegrito';

import Image from 'react-bootstrap/Image';

import header from '../images/bea-header.png'

import constantes from '../helpers/constanteHelper';
import { retornarTexto } from '../helpers/textoHelper'

function DetalhesCertificacaoBEA({ resolucaoMobile, idioma }) {
    return (
        <>
            <Divisor />
            <TituloNegrito texto={retornarTexto(idioma, 'certificacaoBea')} />
            <Image style={{ height: '400px', objectFit: 'contain', padding: '20px' }} src={header} alt='logo' fluid />
            <span className='mb-5' style={{ width: resolucaoMobile ? '90vw' : '70vw', color: constantes.CORES.BRANCO_PADRAO, fontSize: '20px', whiteSpace: 'pre-line', textAlign: resolucaoMobile ? 'justify' : 'center' }}>
                {retornarTexto(idioma, 'descricaoCertificacaoBeaParte1')}<br /><br />
                {retornarTexto(idioma, 'descricaoCertificacaoBeaParte2')}
            </span>
        </>
    );
}
export default DetalhesCertificacaoBEA;
